export default "__VITE_ASSET__DGPgoRc6__"